<template>
<!-- 표준 시나리오 -->
  <div>
    <div  class="cate_wrap" style="margin-bottom:30px;">
      <dl >
        <dt>산업군</dt>
        <dd>
          <ur-segment-wrapper primary sm v-model="industry.industryCode" :checked="true">
            <template v-for="item in industryList">
              <aicc-segment-button :value="item.industryCode" :disabled="!item.activated" :ico="item.industryCode" @click="onClickIndustry(item)">{{item.description}}</aicc-segment-button>            
            </template>
          </ur-segment-wrapper>
        </dd> 
      </dl>
      <dl>
        <dt>업종</dt>
        <dd>
          <ur-segment-wrapper primary sm v-model="business.businessCode" :checked="true">
            <template v-for="item in businessList">
              <ur-segment-button :value="item.businessCode" :disabled="!item.activated" @click="onClickBusiness(item)">{{item.description}}</ur-segment-button>
            </template>
          </ur-segment-wrapper>
        </dd>
      </dl>
      <dl>
        <dt>서비스 유형</dt>
        <dd>
          <ur-segment-wrapper primary sm v-model="service.serviceCode" :checked="true">
            <template v-for="item in serviceList">
              <ur-segment-button :value="item.serviceCode" :disabled="!item.activated" @click="onClickService(item)">{{item.description}}</ur-segment-button>
            </template>
          </ur-segment-wrapper>
        </dd>
      </dl>
      <dl>
        <dt>제공 서비스</dt>
        <dd>
          <ur-segment-wrapper primary sm v-model="callType.callType" :checked="true">
            <template v-for="item in callTypeList">
              <ur-segment-button :value="item.callType" :disabled="!item.activated" @click="onClickCallType(item)">{{getCallType(item.callType)}}</ur-segment-button>
            </template>
          </ur-segment-wrapper>
          <p class="txt_desc">* 추후 다양한 산업군/업종별 제공 서비스가 추가될 예정입니다.</p>  
        </dd>
      </dl>
    </div>  
    <div   class="cate_wrap_w">
      <dl>
        <dt>표준 시나리오</dt>
        <dd style="font-size:14px;">
          <div style="width:912px">
            {{scenarioType}}<ur-button shape="hyperlink" icon="download" @click="onClickScenarioDownload()">시나리오 샘플 다운로드</ur-button>
          </div>
        </dd>
      </dl>
      <dl>
        <dt>시나리오 설명</dt>
        <dd style="font-size:14px;">
          <div style="width:912px;">
            {{summary}}
          </div>
        </dd>
      </dl>
      <dl>
        <dt>시나리오 이름<span class="essential">*</span></dt>
        <dd>
          <aicc-text-field v-model="scenarioRequestAsk.scenarioName" :disabled="false" :clearable="true" :readonly="false" :width="680" :counter="scenarioNameMaxLength" :rules="validateRule" ref="scenarioName" @blur="onBlurTrimValidate" @input="onInput" placeholder="시나리오 이름을 입력해주세요." />
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'CMP_AID_00003', // eslint-disable-line vue/name-property-casing
  components: {},
  extends: BasePage,
  props: {
    parentPageId: { type: String, required: true },
    scenarioNameItems: { type: Array, default: () => [] },
  },
  data() {
    return {
      // 산업군
      industryList: [],
      industry: {},

      // 업종
      businessList: [],
      business: {},

      // 서비스 유형
      serviceList: [],
      service: {},

      // 제공 서비스(아웃바운드콜/인바운드콜)
      callTypeList: [],
      callType: {},

      // 템플릿 시나리오 정보
      scenarioType: '',
      summary: '',
      fileId: '',

      // 표준 시나리오
      scenarioRequestAsk: {
        templateScenarioId: '',
        scenarioName: '',
        summary: '',
      },

      // validator
      validateRule: [
        (v) => !!v || '필수 입력 항목입니다.',
        (v) => this.scenarioNameCheckflag || '기존에 사용하지 않은 시나리오 이름을 입력해주세요.',
        (v) => aiccUtils.getStringByteSize(this.scenarioRequestAsk.scenarioName) <= this.scenarioNameMaxLength || `최대 ${this.scenarioNameMaxLength}byte까지 입력 가능합니다.`,
      ],
      scenarioNameCheckflag: true,
      scenarioNameMaxLength: 70, // byte

    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      this.onClickStandardScenario();
    },

    // 제공 서비스 유형 코드 -> 텍스트
    getCallType(code) {
      return aiccCode.scenarioCallType.codeText(code);
    },

    // 표준 시나리오 일괄 조회
    onClickStandardScenario() {
      http.request(this.parentPageId, 'DTS_AID_00026', {
      }).then(res => {
        this.industryList = res.data.industryList;
        for (var item of this.industryList) {
          if (item.activated) { // 활성화된 타입 중 첫 번째 타입이 default
            this.onClickIndustry(item);
            break;
          }
        }
      });
    },

    // 산업군 선택
    onClickIndustry(industry) {
      this.industry = industry;
      this.businessList = industry.businessList;
      for (var item of this.businessList) {
        if (item.activated) { // 활성화된 타입 중 첫 번째 타입이 default
          this.onClickBusiness(item);
          break;
        }
      }
    },

    // 업종 선택
    onClickBusiness(business) {
      this.business = business;
      this.serviceList = business.serviceList;
      for (var item of this.serviceList) {
        if (item.activated) { // 활성화된 타입 중 첫 번째 타입이 default
          this.onClickService(item);
          break;
        }
      }
    },

    // 서비스 유형 선택
    onClickService(service) {
      this.service = service;
      this.callTypeList = service.callTypeList;
      for (var item of this.callTypeList) {
        if (item.activated) { // 활성화된 타입 중 첫 번째 타입이 default
          this.onClickCallType(item);
          break;
        }
      }
    },

    // 제공 서비스 선택
    onClickCallType(callType) {
      this.callType = callType;

      this.scenarioType = this.industry.description + ' > ' +
                          this.business.description + ' > ' +
                          this.service.description + ' > ' + 
                          this.getCallType(this.callType.callType);
      this.fileId = this.callType.fileId;
      this.summary = this.callType.summary;
      this.scenarioRequestAsk.scenarioName = this.callType.scenarioName;
    },

    // 시나리오 샘플 다운로드
    onClickScenarioDownload() {
      http.request(this.parentPageId, 'DTS_AIM_00011', {
        path: {
          'file-id': this.fileId,
        },
      }).then(res => {
        aiccUtils.fileDownload.downloadBase64(res.data.file.file, res.data.file.fileName, 'image/jpeg');
      });
    },

    // 표준 시나리오 신청
    onBlurTrimValidate() {
      this.scenarioRequestAsk.scenarioName = this.scenarioRequestAsk.scenarioName.trim();
      this.$nextTick(() => {
        this.scenarioNameCheckflag = !this.scenarioNameItems.includes(this.scenarioRequestAsk.scenarioName);
        this.$refs.scenarioName.validate();
      });
    },
    onInput() {
      this.scenarioNameCheckflag = true;
    },

    request() {
      if (this.$refs.scenarioName.isValid()) {
        this.scenarioRequestAsk.templateScenarioId = this.callType.scenarioId;
        this.scenarioRequestAsk.summary = this.summary;

        http.request(this.parentPageId, 'DTS_AID_00015', {
          data: this.scenarioRequestAsk,
        }).then(res => {
          if (res.data.reply.code === '0000') {
            this.$emit('complete');
          } else if (res.data.reply.code === '2003') { // 시나리오 이름 중복
            this.scenarioNameCheckflag = false;
            this.$refs.scenarioName.validate();
          } else {
            utils.aiccMessageBox('확인', res.data.reply.korMsg, '확인', null);
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.cate_wrap .txt_desc {font-size: 12px; position: absolute; right: 32px; bottom: 24px;}
</style>
